/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SortExpression } from './sort-expression';
import { EquipmentScheduleTypes } from './equipment-schedule-types';


export interface SearchEquipmentWithSchedulesRequest { 
    skip?: number;
    take?: number;
    includeTotalCount?: boolean | null;
    sortExpressions?: Array<SortExpression> | null;
    keyword?: string | null;
    ipRanges?: Array<string> | null;
    excludeIpRanges?: Array<string> | null;
    ipList?: Array<string> | null;
    modelIds?: Array<string> | null;
    workerIds?: Array<string> | null;
    clientIds?: Array<string> | null;
    facilityIds?: Array<string> | null;
    containerIds?: Array<string> | null;
    statusIds?: Array<number> | null;
    modeIds?: Array<number> | null;
    scheduleType?: EquipmentScheduleTypes;
    includeFinishedCalendars?: boolean;
}



